module.exports = __webpack_public_path__ + "img/image3.8b42ef00.png";